import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PurchaseInvoice, PurchaseInvoiceCreate, PurchaseInvoiceFilter } from '../data/purchaseInvoice';

export function createPurchaseInvoiceService(client: AxiosInstance) {
  return createCrudService<PurchaseInvoice, PurchaseInvoiceCreate, PurchaseInvoiceFilter>(
    client,
    '/purchase/PurchaseInvoice',
    'id',
  );
}

export type PurchaseInvoiceService = CrudService<PurchaseInvoice, PurchaseInvoiceCreate, PurchaseInvoiceFilter>;
